import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraSpinner } from '@mono/ui-components/ensigns';
import { SpecraEmptyState } from '@mono/ui-components/lieutenants';
import { Navigate, useLocation } from 'react-router-dom';
import { rfiQuestionHref } from '../../../components/RecordShell/rfiNav';
import { useRfiRecord } from './RfiRecordContext';
import { useRfiAnswerSections } from './useRfiAnswerSections';
/** Bare `questions` → the first question (§4.2); keeps the query string (`?side=assist`). */ export function RfiQuestionsIndex() {
    const record = useRfiRecord();
    const { search } = useLocation();
    const { sections, isLoading } = useRfiAnswerSections(record?.pangaeaId ?? '');
    if (!record || isLoading) return /*#__PURE__*/ _jsx(SpecraSpinner, {
        className: "m-[var(--space-6)]",
        label: "Loading questions"
    });
    const first = sections[0];
    if (!first) {
        return /*#__PURE__*/ _jsx(Navigate, {
            replace: true,
            to: `/rfi-response/${record.routeId}/document${search}`
        });
    }
    return /*#__PURE__*/ _jsx(Navigate, {
        replace: true,
        to: `${rfiQuestionHref(record.routeId, first.id)}${search}`
    });
}
/** Placeholder for record pages later tickets build (WRT-06 Home, WRT-07 pages). */ export function RfiPagePlaceholder({ title }) {
    return /*#__PURE__*/ _jsx(SpecraEmptyState, {
        className: "m-[var(--space-6)]",
        description: "This page arrives with the RFI workspace. Use the response document for now.",
        framed: true,
        title: title
    });
}
